import { useEffect, useState } from 'react';
import type { AIGeneratedContent } from '@data/publicPlans';
import { useI18n } from '../i18n';
import { translateAIContent } from '@services/aiPlanTranslation';

export function useTranslatedAIContent(content: AIGeneratedContent | null | undefined) {
	const { language } = useI18n();
	const [translated, setTranslated] = useState<AIGeneratedContent | null | undefined>(content);
	const [isTranslating, setIsTranslating] = useState(false);

	useEffect(() => {
		let cancelled = false;
		if (!content) {
			setTranslated(content);
			setIsTranslating(false);
			return;
		}

		if (content.contentLanguage === language || (!content.contentLanguage && language === 'en')) {
			setTranslated(content);
			setIsTranslating(false);
			return;
		}

		setTranslated(content);
		setIsTranslating(true);

		translateAIContent(content, language)
			.then((res) => {
				if (!cancelled) {
					setTranslated(res);
				}
			})
			.finally(() => {
				if (!cancelled) {
					setIsTranslating(false);
				}
			});

		return () => {
			cancelled = true;
		};
	}, [content, language]);

	return { translatedContent: translated, isTranslating };
}

